import { render } from "./IpRangesTabGuest.vue?vue&type=template&id=42c4abe8&scoped=true"
import script from "./IpRangesTabGuest.vue?vue&type=script&lang=js"
export * from "./IpRangesTabGuest.vue?vue&type=script&lang=js"

import "./IpRangesTabGuest.vue?vue&type=style&index=0&id=42c4abe8&lang=scss&scoped=true"

import exportComponent from "/jenkins/workspace/acs-centos8-pkg-builder/dist/rpmbuild/BUILD/cloudstack-4.21.0.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c4abe8"]])

export default __exports__